<template>
  <div id="header">
    <nav id="topnavbar" class="navbar" style="position: fixed;">
      <div class="wrap">
        <div class="logo">
          <img src="../../assets/logo.png" alt="">
        </div>
        <ul class="wrap-list clearfix">
          <li><router-link to="/" exact>首页</router-link></li>
          <li><router-link to="/solution">解决方案</router-link></li>
          <li><router-link to="/case">典型案例</router-link></li>
          <li><router-link to="/lxju">领先技术</router-link></li>
          <li><router-link to="/hzdz">合作定制</router-link></li>
          <li><router-link to="/about">关于我们</router-link></li>
          <!-- <li><router-link to="/service">产品服务</router-link></li> -->
          <!-- <li><router-link to="/mall">绽放商城</router-link></li> -->
        </ul>
        <div class="menu-icon"></div>
      </div>
      <div class="z-nav" :class="searchBar == true ? 'active' :''"></div>
    </nav>
  </div>
</template>

<script>
  export default {
    name: '',
    data () {
      return {
        scroll: '',
        searchBar: false
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        //console.log(scrollTop);
        if (scrollTop >50) {
          this.searchBar = true;
        }else{
          this.searchBar = false;
        }
      }
    }

  }
</script>
<style scoped>
  .navbar{
    width: 100%;
    height: 80px;
    z-index: 333;
  }
  .z-nav{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .7;
    z-index: -1;
    transition: all .6s cubic-bezier(0.65, 0.22, 1, 1);
  }
  .z-nav.active{
    background: #2e2e2e;
  }
  .wrap{
    position: relative;
    max-width: 1200px;
    height: 100%;
    margin: 0 auto;
  }
  .logo{
    position: absolute;
    left: 0;
    top: 0;
    width: 175px;
    height: 80px;
    transition: all .6s;
  }
  .logo img{
    width: 100%;
    height: 100%;
  }
  .wrap-list {
    position: absolute;
    right: 0;
    top: 0;
    width: auto;
    height: 100%;
  }
  .wrap-list li{
    height: 100%;
    float: left;
  }
  .wrap-list li>a{
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
    color: #d0d3da;
    display: block;
    padding: 30px 13px;
    line-height: 100%;
    transition: all .3s;
  }
  .wrap-list li>a:hover{
    color: #fff;
  }
  .wrap-list .active{
    color: #ffffff;
    /* background-color: #fff; */
  }
  .wrap-list .router-link-active{
    color: #ffffff;
    position: relative;
  }
  .wrap-list .router-link-active::before{
    content: '';
    background-color: red;
    width: 100%;
    height: 4px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .menu-icon{
    display: none;
    position: absolute;
    right: 20px;
    top: 13px;
    width: 34px;
    height: 34px;
    background: url("../../../static/images/cd.png") no-repeat;
    background-size: 100%;
  }
  @media (max-width: 1199px) and (min-width: 992px){
    .navbar{
      height: 60px;
    }
    .wrap-list li>a{
      font-size: 14px;
      padding: 23px 13px;
    }
    .logo{
      width: 155px;
      height: 60px;
    }
  }
  @media (max-width: 991px) and (min-width: 768px){
    .navbar{
      height: 60px;
    }
    .wrap-list li>a{
      font-size: 14px;
      padding: 23px 13px;
    }
    .logo{
      width: 155px;
      height: 60px;
    }
  }
  @media screen and (max-width: 767px){
    .wrap-list {
      display: none;
    }
    .navbar{
      height: 50px;
    }
    .wrap-list li>a{
      font-size: 14px;
      padding: 23px 13px;
    }
    .logo{
      width: 105px;
      height: 50px;
    }
    .menu-icon{
      display: block;
      right: 10px;
      top: 10px;
      width: 30px;
      height: 30px;
    }

  }
  @media (min-width: 768px){

  }
</style>




// WEBPACK FOOTER //
// src/components/header/header.vue